export default __webpack_public_path__ + "static/media/8706c0b6-b423-44f7-ae1a-dd0aabd8a542.81ca519d.eot";